import { render } from "./AttendanceTag.vue?vue&type=template&id=8c5e5ae8&scoped=true"
import script from "./AttendanceTag.vue?vue&type=script&lang=js"
export * from "./AttendanceTag.vue?vue&type=script&lang=js"

import "./AttendanceTag.vue?vue&type=style&index=0&id=8c5e5ae8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c5e5ae8"]])

export default __exports__